<div class="card mt-4"></div>
    <div class="card-body">
        <h4>Client status </h4>
        <ng-container *ngIf="displayLoader">
          <div class="loader-container" style="width: 55%">
            <ng-container *ngFor="let i of [1,2,3,4,5,6,7]">
              <li class="t_loader">
                <div class="card__desc load" [id]="i % 2 === 0 ? '' : 'long'"></div>
              </li>
            </ng-container>
          </div>
        </ng-container>       
        <div *ngIf="!displayLoader" class="row">
            <table class=" col-8 table table-hover table-borderless table-hover">
                <thead>
                    <ng-container *ngIf="!statusData; else dataBlock">
                        <tr>
                            <td colspan="3">No data</td>
                        </tr>
                    </ng-container>
                    <ng-template #dataBlock> 
                      <tr>
                        <th>Personal Details</th>
                        <th>
                          <app-status-icons [statusValue]="statusData?.profileStatus"></app-status-icons>                        </th>
                    </tr>
                    <tr>
                        <th>Job Compliance</th>
                        <th>
                            <app-status-icons [statusValue]="statusData?.jobStatus"></app-status-icons>
                        </th>
                    </tr>
                    </ng-template>
                </thead>
            </table>
        </div>
    </div>